export default "__VITE_ASSET__f71f0472__"